import { getApiBaseUrl } from './services/api';

// Confirm API base URL from .env is available at startup
export const detectServerPort = async () => {
  const baseUrl = getApiBaseUrl();
  console.log('Using API base URL from .env:', baseUrl);
  return baseUrl;
};
